import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import Modal from 'react-modal';
import Page from "../DefaultPage/DefaultPage";
import Backdrop from "../BackDrop/BackDrop";
import { useTranslation } from "react-i18next";
import DarkModeContext from "../../store/DarkModeContext";
import { useContext } from "react";
import { lightModeColors, darkModeColors } from "../../utils/colors";

const MapComponent = (props) => {
  const [tg, i18] = useTranslation("global");
  const [clickedLocation, setClickedLocation] = useState(props.location);
  const { darkMode} = useContext(DarkModeContext);
  const { textColor, backgroundColor, cardColor } = darkMode ? darkModeColors : lightModeColors;
  
  const MapClickHandler = () => {

    const map = useMapEvents({
      click: (e) => {
        const { lat, lng } = e.latlng; 
        console.log("Clicked on the map. Latitude:", lat, "Longitude:", lng);
        setClickedLocation([lat, lng]);
        props.onLocationClick([lat, lng]);
      },
    });

    return null;
  };




  const customIcon = new L.Icon({
    iconUrl: process.env.PUBLIC_URL + '/images/png-transparent-tracker-map-indicator-pointer-pin-position-location-green-thumbnail-removebg-preview.png',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });
  const buttonStyle = {
    padding: "10px 20px",
    border: "none",
    width : "20%",
    borderRadius: "5px",
    backgroundColor: "#067451",
    color: "white",
    cursor: "pointer",
    zIndex: 10
  };

  return (
    <div style={{
      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
      borderRadius: "6px",
      backgroundColor: "white",
      padding: "3rem",
      textAlign: "center",
      width: "750px",
      zIndex: 10,
      position: "fixed",
      left: "calc(50% - 405px)", 
      top: "calc(40% - 250px)",
      alignItems: "center",
      backgroundColor: cardColor,
      zIndex: 100,
    }}> 
        <div style={{ padding: '0px' }}>
          <h2>{tg("global.map.MAP")}</h2>
          <p>{tg("global.map.clickMapExplanation")}</p>
          <h3>{tg("global.map.Lat")} {clickedLocation ? clickedLocation[0] : (tg("global.map.NA"))}</h3>
          <h3>{tg("global.map.Lng")} {clickedLocation ? clickedLocation[1] : (tg("global.map.NA"))}</h3>
          <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
          <button style={buttonStyle} onClick={() => setClickedLocation(null)}>{tg("global.map.clear")}</button>
          <span style={{width: "30px"}}></span>
          <button style={buttonStyle} onClick={() => props.onDoneClick()}>{tg("global.map.done")}</button>
          </div>
        </div>

        <MapContainer center={[40.202000, -8.413313]} zoom={14} style={{ display: "flex", alignItems:"center", justifyContent: "center", height: "450px", width: "500px",  margin: "auto", flexDirection: "column",
    justifyContent: "center",}}>
          <MapClickHandler />
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />

          {clickedLocation && (
            <Marker position={clickedLocation} icon={customIcon}>
              <Popup>
              {tg("global.map.youClickedHere")}<br />
              {tg("global.map.Lat")} {clickedLocation[0]}, {tg("global.map.Lng")} {clickedLocation[1]}
              </Popup>
            </Marker>
          )}
        </MapContainer>
      </div>
  );
};

export default MapComponent;
